






























































































import { Component, Vue, Mixins } from 'vue-property-decorator';

// Services
import Staff from '@/services/Staff';
import * as Sentry from '@sentry/browser';
import Claims from '@/services/Claims';

// Mixins
import UpdateClaimMixin from '@/mixins/Staff/Claims/UpdateClaim';

// Components
import Alert from '@/components/Global/Alert.vue';
import Loading from '@/components/Global/Loading.vue';
import TextField from '@/components/Form/TextField.vue';
import SelectField from '@/components/Form/SelectField.vue';
import SwitchField from '@/components/Form/SwitchField.vue';
import TextArea from '@/components/Form/TextArea.vue';

import AdditionalFields from '@/components/Staff/Claims/AdditionalFields.vue';
import NewClaimsFormSingle from './NewClaimsFormSingle.vue';
import OldClaimsFormSingle from './OldClaimsFormSingle.vue';
import EmailClaimFormModal from '@/components/Modal/EmailClaimForm.vue';
import jspdf from 'jspdf';
import html2canvas from 'html2canvas';
// Validations
import { email, maxLength } from 'vuelidate/lib/validators';
import { Features } from '@/services/Features';
import jQuery from 'jquery';
import UpdateClaim from '@/mixins/Staff/Claims/UpdateClaim';
@Component({
	name: 'PageStaffClaimsSingle',
	components: {
		Alert,
		Loading,
		SelectField,
		TextField,
		TextArea,
		SwitchField,
		AdditionalFields,
		NewClaimsFormSingle,
		OldClaimsFormSingle,
		EmailClaimFormModal,
	},
})
export default class ClaimsSingle extends Mixins(UpdateClaimMixin) {
	public errorSave: boolean = false;
	public success: boolean = false;
	public claimId: string = '';
	public claim: any = {};
	public claimStatus: string = '';
	public assignee: string = '';
	public comments: string = '';
	public setup: boolean = false;
	public isInvalid: boolean = false;
	public loading: boolean = true;
	public error: boolean = false;
	public emailStatus: string = '';

	public isOldClaim: boolean = false;
	public insuredName: string = '';
	private readonly Features = Features;
	private goToTop() {
		window.scrollTo(0, 0);
	}

	private download() {
		try {
			const HTML_Width = document.querySelector('#claimForm').clientWidth;
			const HTML_Height = document.querySelector('#claimForm').clientHeight;
			const top_left_margin = 0;
			const PDF_Width = HTML_Width + top_left_margin * 2;
			const PDF_Height = PDF_Width * 1.5 + top_left_margin * 2;
			const canvas_image_width = HTML_Width;
			const canvas_image_height = HTML_Height;

			const totalPDFPages = Math.ceil(HTML_Height / PDF_Height) - 1;
			window.scrollTo(0, 0);
			let oldTextArea;
			oldTextArea = document.querySelector('#textAreaComments');
			const div = document.createElement('div');
			div.innerHTML = document
				.querySelector('#textAreaComments')
				.innerHTML.replace(/\n/g, '<br>');
			document.querySelector('#textAreaComments').replaceWith(div);

			html2canvas(document.querySelector('#claimForm')).then(async canvas => {
				console.log(canvas.height + '  ' + canvas.width);

				const imgData = canvas.toDataURL('image/jpeg');
				div.replaceWith(oldTextArea);
				const pdf = new jspdf('p', 'pt', [PDF_Width, PDF_Height]);
				pdf.addImage(
					imgData,
					'JPEG',
					top_left_margin,
					top_left_margin,
					canvas_image_width,
					canvas_image_height,
				);

				for (let i = 1; i <= totalPDFPages; i++) {
					pdf.addPage(PDF_Width, PDF_Height);
					pdf.addImage(
						imgData,
						'JPEG',
						top_left_margin,
						-(PDF_Height * i) + top_left_margin * 4,
						canvas_image_width,
						canvas_image_height,
					);
				}

				pdf.save('Loss Notice - ' + this.insuredName + '.pdf');
			});
		} catch (e) {
			Sentry.captureException(e);

			this.$emit('update:emailStatus', 'There was an error in emailing the claim form!');
		} finally {
			this.$emit('update:loading', false);
			this.$emit('update:emailStatus', 'Claim Form has been emailed!');
		}
	}
	private async created() {
		this.claimId = this.$route.params.id;

		try {
			const getClaim = await Staff.getClaim(this.claimId);

			if ('claim_data' in getClaim.data) {
				this.claim = getClaim.data;
				if (!this.claim.claim_data.informationAboutTheClaimIncident) {
					this.isOldClaim = true;
				} else {
					this.isOldClaim = false;
				}

				if (
					this.claim &&
					this.claim.claim_data &&
					this.claim.claim_data.insuredsPolicyInformation
				) {
					this.insuredName = this.claim.claim_data.insuredsPolicyInformation.nameOfInsured;
				}

				if ('comments' in this.claim) {
					this.comments = this.claim.comments;
				}
				if ('additionalFields' in this.claim) {
					this.additionalFields = this.claim.additionalFields;
				}
				if ('setup' in this.claim) {
					this.setup = this.claim.setup;
				}
				if ('assignee' in this.claim) {
					this.assignee = this.claim.assignee;
				}
				if ('real_claim_id' in this.claim) {
					this.realClaimId = this.claim.real_claim_id;
				}
				if ('peerSupportRequested' in this.claim) {
					this.peerSupportRequested = this.claim.peerSupportRequested;
				}

				this.claimStatus = Claims.getClaimStatus(this.claim);
			}
		} catch (e) {
			Sentry.captureException(e);
			this.error = true;
		} finally {
			this.loading = false;
		}
	}
}
